import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Form, Table, Button } from "react-bootstrap";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { toast } from "react-toastify";
import { useLocation, useParams, Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { compact, isEmpty, isNumber, startCase } from "lodash";
import AuthContext from "../context/AuthContext";
import helpers from "../utils/helpers";
import moment from "moment";
import { Helmet } from "react-helmet";
import { CiSquarePlus, CiSquareMinus } from "react-icons/ci";
import objNew from "../utils/constants";
import Pagination from "../components/Pagination";
import { BiSolidRightArrow } from "react-icons/bi";
import { format } from "date-fns";
import DatePicker from "react-datepicker";

const AprofitMarket = () => {
  const parmas = useParams();
  const location = useLocation();
  const user_params = compact(location.pathname.split("/"));
  let { user, setAccountError } = useContext(AuthContext);
  let check = user_params[0];
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  const [id, setId] = useState("");
  const [getProperty, setProperty] = useState("none");
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [detailsData, setDetailsData] = useState([]);
  const [filter, setFilter] = useState({
    page: 1,
    page_size: 50,
    fromPeriod: previousDate,
    toPeriod: currentDate,
    filterByDay: "",
    created_by: parmas?.id ? parmas.id : user?._id,
    userType: parmas?.user_type ? parmas.user_type : user?.userType,
    eventType: "all",
    limit: 50,
  });

  const showDetail = async (event, eventId, eventType) => {
    setDetailsData([]);
    try {
      const { status, data: response_users } = await apiGet(
        apiPath.reportMarketDetail +
          "?fromPeriod=" +
          filter.fromPeriod +
          "&toPeriod=" +
          filter.toPeriod +
          "&eventType=" +
          eventType +
          "&eventId=" +
          eventId,
      );
      if (status === 200) {
        if (response_users.success) {
          setDetailsData(response_users.results);
          // const detailDiv = document.getElementById(eventId);
          // let table =
          //   '<td colSpan="10" class="abc"><table width="100%" class="sub-table ">';
          // response_users.results.forEach((item, index) => {
          //   table = table + `<tr>`;
          //   table =
          //     table +
          //     `<td >${
          //       item?.betFaireType == "betfair"
          //         ? "Match Odds"
          //         : startCase(item?.betFaireType)
          //     }</td>`;
          //   table = table + `<td>0</td>`;
          //   table =
          //     table +
          //     `<td>${
          //       item?.amount
          //         ? Math.sign(item?.amount) === -1
          //           ? "<span class='text-danger'>" +
          //             "(" +
          //             helpers.currencyFormat(item?.amount) +
          //             ")" +
          //             "</span>"
          //           : "<span class='text-success'>" +
          //             helpers.currencyFormat(Math.abs(item?.amount))
          //         : ""
          //     }</span></td>`;
          //   table =
          //     table +
          //     `<td>${
          //       item?.amount
          //         ? Math.sign(item?.amount) !== -1
          //           ? "<span class='text-danger'>" +
          //             "(" +
          //             "-" +
          //             helpers.currencyFormat(item?.amount) +
          //             ")" +
          //             "</span>"
          //           : "<span class='text-success'>" +
          //             helpers.currencyFormat(Math.abs(item?.amount))
          //         : ""
          //     }</span></td>`;
          //   table = table + `<td>0</td>`;
          //   table = table + `<td>0</td>`;
          //   table = table + `<td>0</td>`;
          //   table = table + `<td>0</td>`;
          //   table =
          //     table + `<td>${helpers.currencyFormat(item?.commission)}</td>`;
          //   table =
          //     table +
          //     `<td>${
          //       item?.amount
          //         ? Math.sign(item?.amount) !== -1
          //           ? "<span class='text-danger'>" +
          //             "(" +
          //             "-" +
          //             helpers.currencyFormat(item?.amount) +
          //             ")" +
          //             "</span>"
          //           : "<span class='text-success'>" +
          //             helpers.currencyFormat(Math.abs(item?.amount))
          //         : ""
          //     }</span></td>`;
          //   // table =
          //   //   table +
          //   //   `<td style="min-width:120px"><a style="padding: 5px ;text-decoration:none" class='me-0 theme_light_btn' href="/match-market-bets/${eventId}/${item?.betFaireType}" target="_blank">Show Bets</a></td>`;
          //   // table += `</tr>`;
          // });
          // table += "</table></td >";

          // if (detailDiv.style.display === "none") {
          //   detailDiv.style.setProperty("display", "contents");
          //   event.target.className = "fas fa-minus-square pe-2";
          //   detailDiv.innerHTML = table;
          // } else {
          //   detailDiv.style.setProperty("display", "none");
          //   event.target.className = "fas fa-plus-square pe-2";
          // }
        }
      }
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };
  useEffect(() => {
    setFilter((prevState) => {
      return {
        ...prevState,
        created_by: parmas?.id ? parmas.id : user?._id,
        userType: parmas?.user_type ? parmas.user_type : user?.userType,
      };
    });
  }, [parmas?.id]);
  const [obj, setObj] = useState({});
  const [data, setData] = useState([]);

  const getData = async () => {
    if (filter.filterByDay != "") {
      if (filter.filterByDay == "today") {
        filter.fromPeriod = currentDate;
        filter.toPeriod = currentDate;
      }
      if (filter.filterByDay == "yesterday") {
        filter.fromPeriod = previousDate;
        filter.toPeriod = currentDate;
      }
    }
    let path = apiPath.reportMarket;

    try {
      const { status, data: response_users } = await apiGet(path, filter);
      if (status === 200) {
        if (response_users.success) {
          setData(response_users.results.data);
          //setSumData(response_users.results.sumData);

          if (response_users.results.data?.length == 0) {
            setAccountError(true);
          } else {
            setAccountError(false);
          }
          setPageCount(response_users.results.totalPages);
          const commission = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.commission);
            return a;
          }, 0);
          // const stake = response_users?.results?.data?.reduce((a, v) => {
          //   a = parseInt(a) + parseInt(v?.stake?.realAmount);
          //   return a;
          // }, 0);
          const downlinePnl = response_users?.results?.data?.reduce((a, v) => {
            a = parseFloat(a) + parseFloat(v?.amount);
            return a;
          }, 0);

          setObj({
            commission: commission || 0,
            stake: response_users?.results?.data?.reduce((a, v) => {
              a = parseFloat(a) + parseFloat(v?.stake);
              return a;
            }, 0),
            downlinePnl: downlinePnl || 0,
          });
        }
      }
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  useEffect(() => {
    //  getData();
    setViewPage(filter.page ? filter.page - 1 : 0);
  }, [filter?.eventType]);
  useEffect(() => {
    // getData();
  }, [filter?.filterByDay]);
  const handlePageClick = (event) => {
    setFilter((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
  };

  return (
    <div className="top-header-inner">
      <section className="main-inner-outer py-4">
        <Container fluid>
          <Row>
            <div className="db-sec">
              <h2 className="common-heading">
                Profit/Loss Report by{" "}
                {check == "AprofitMarket" ? "Market" : "Downline"}
              </h2>
            </div>

            <div className="inner-wrapper">
              <Form className="bet_status">
                <div
                  className="mb-lg-0 mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div className="bet-sec" style={{ marginRight: "17px" }}>
                    <Form.Label className="mb-0">Sports</Form.Label>
                    <Form.Select
                      className="small_select"
                      style={{ minWidth: "100px" }}
                      onChange={(e) =>
                        setFilter({
                          ...filter,
                          eventType: e.target.value,
                        })
                      }
                      value={filter.eventType}
                      aria-label="Default select example"
                    >
                      <option value={"all"}>All</option>
                      <option value={4}>Cricket</option>
                      <option value={2}>Tennis</option>
                      <option value={1}>Soccer</option>{" "}
                      <option value={-1}>Casino</option>
                    </Form.Select>
                  </div>

                  <div className="bet-sec" style={{ marginRight: "17px" }}>
                    <Form.Label className="mb-0">Time Zone</Form.Label>
                    <Form.Select
                      className="small_select"
                      style={{ minWidth: "80px", width: "130px" }}
                      onChange={(e) =>
                        setFilter({
                          ...filter,
                          timeZone: e.target.value,
                        })
                      }
                      value={filter.timeZone}
                      aria-label="Default select example"
                    >
                      {/* <option value={""}>All</option> */}
                      <option value={""}>
                        IST(Bangalore / Bombay / New Delhi) (GMT+5:30)
                      </option>
                      {/* <option value={2}>Tennis</option>
                              <option value={1}>Soccer</option> */}
                    </Form.Select>
                  </div>
                  <div
                    className="bet-sec bet-period bettinghistory-tab"
                    style={{ marginRight: "6px", width: "235px" }}
                  >
                    <Form.Label
                      className="mb-0"
                      style={{ marginBottom: "7px" }}
                    >
                      Period
                    </Form.Label>
                    <Form.Group className="form-group">
                      <DatePicker
                        className="small_form_control"
                        selected={
                          filter.fromPeriod ? new Date(filter.fromPeriod) : null
                        }
                        onChange={(date) =>
                          setFilter({
                            ...filter,
                            fromPeriod: date.toISOString().split("T")[0],
                            filterByDay: "",
                          })
                        }
                        dateFormat="yyyy-MM-dd"
                        maxDate={new Date()}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                        placeholderText="Select a date"
                        onFocus={(e) => e.target.blur()}
                      />
                      <Form.Control
                        style={{ marginLeft: "4px" }}
                        className="small_form_control"
                        type="text"
                        placeholder="09:00"
                        disabled
                      />
                    </Form.Group>
                  </div>

                  <div className="bet-sec bet-period">
                    <Form.Label
                      style={{ marginRight: "2px", marginBottom: `0px` }}
                      className="mb-0"
                    >
                      to
                    </Form.Label>
                    <Form.Group className="form-group">
                      <DatePicker
                        className="small_form_control"
                        selected={
                          filter.toPeriod ? new Date(filter.toPeriod) : null
                        }
                        onChange={(date) =>
                          setFilter({
                            ...filter,
                            toPeriod: date.toISOString().split("T")[0],
                            filterByDay: "",
                          })
                        }
                        dateFormat="yyyy-MM-dd"
                        minDate={
                          filter?.fromPeriod
                            ? new Date(filter?.fromPeriod)
                                .toISOString()
                                .split("T")[0]
                            : new Date()
                        }
                        maxDate={new Date().toISOString().split("T")[0]}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                        placeholderText="Select a date"
                        onFocus={(e) => e.target.blur()}
                      />
                      <Form.Control
                        style={{ marginLeft: "4px", width: "47px" }}
                        className="small_form_control"
                        type="text"
                        placeholder="08:59"
                        disabled
                      />
                    </Form.Group>
                  </div>
                </div>
                {/* <Col
                          lg={2}
                          sm={6}
                          className="mb-lg-0 mb-3 flex-grow-0 "
                        >
                       
                        </Col>
                        <Col
                          style={{ padding: "0" }}
                          lg={2}
                          sm={6}
                          className="mb-lg-0 mb-3 flex-grow-0"
                        >
                 
                        </Col> */}

                <div className="history-btn mt-2">
                  <ul className="list-unstyled mb-0">
                    <li>
                      <Button
                        className={
                          // filter.filterByDay === "today"
                          //   ? "me-0 theme_dark_btn"
                          //   :
                          "me-0 theme_light_btn"
                        }
                        onClick={(e) =>
                          setFilter({
                            ...filter,
                            filterByDay: "today",
                          })
                        }
                        style={{ padding: `0 10px`, lineHeight: `25px` }}
                      >
                        Just For Today
                      </Button>
                    </li>
                    <li>
                      <Button
                        className={
                          // filter.filterByDay === "yesterday"
                          //   ? "me-0 theme_dark_btn"
                          //   :
                          "me-0 theme_light_btn"
                        }
                        onClick={(e) =>
                          setFilter({
                            ...filter,
                            filterByDay: "yesterday",
                          })
                        }
                        style={{ padding: `0 10px`, lineHeight: `25px` }}
                      >
                        From Yesterday
                      </Button>
                    </li>
                    <li>
                      <Button
                        className="theme_dark_btn"
                        onClick={() => getData("search")}
                      >
                        Get P & L
                      </Button>
                    </li>
                  </ul>
                </div>
              </Form>
            </div>

            {/* <Col md={6} className="">
              <div className="d-flex flex-wrap live-match-bat justify-sm-content-end">
                <Button
                  onClick={(e) =>
                    setFilter({
                      ...filter,
                      eventType: 4,
                    })
                  }
                  className={
                    filter.eventType == "4"
                      ? "mb-2 mx-1  green-btn"
                      : "mb-2 mx-1 theme_light_btn"
                  }
                >
                  Cricket
                </Button>
                <Button
                  onClick={(e) =>
                    setFilter({
                      ...filter,
                      eventType: 1,
                    })
                  }
                  className={
                    filter.eventType == "1"
                      ? "mb-2 mx-1  green-btn"
                      : "mb-2 mx-1 theme_light_btn"
                  }
                >
                  Soccer
                </Button>
                <Button
                  onClick={(e) =>
                    setFilter({
                      ...filter,
                      eventType: 2,
                    })
                  }
                  className={
                    filter.eventType == "2"
                      ? "mb-2 mx-1  green-btn"
                      : "mb-2 mx-1 theme_light_btn"
                  }
                >
                  Tenis
                </Button>
              </div>
            </Col> */}
            {data && data?.length > 0 ? (
              <Col md={12} sm={12} lg={12} className="mt-2">
                <section className="account-table aprofit-downline aprofit-market w-100">
                  <div className="responsive transaction-history table-color profit-market-new">
                    <Table>
                      <thead>
                        <tr>
                          <th scope="col">UID</th>
                          {/* <th scope="col">Stake</th> */}
                          <th style={{ textAlign: "right" }} scope="col">
                            Stake
                          </th>{" "}
                          <th style={{ textAlign: "right" }} scope="col">
                            Player P/L
                          </th>
                          <th style={{ textAlign: "right" }} scope="col">
                            Downline P/L
                          </th>
                          {!user?.userType == "agent" && (
                            <>
                              <th style={{ textAlign: "right" }} scope="col">
                                SS PT
                              </th>{" "}
                              <th scope="col">SS Comm.</th>{" "}
                              <th style={{ textAlign: "right" }} scope="col">
                                SS Rebate
                              </th>{" "}
                              <th style={{ textAlign: "right" }} scope="col">
                                SS Total
                              </th>
                            </>
                          )}{" "}
                          <th style={{ textAlign: "right" }} scope="col">
                            Comm.
                          </th>{" "}
                          <th
                            style={{ textAlign: "right" }}
                            scope="col"
                            colSpan={2}
                          >
                            Upline P/L
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <>
                          {data && data?.length > 0 ? (
                            data?.map((item, index) => {
                              return (
                                <>
                                  {item?.amount != 0 ? (
                                    <>
                                      <tr key={index + 1}>
                                        <td>
                                          <>
                                            {id == item?._id ? (
                                              <img
                                                onClick={() => setId("")}
                                                style={{
                                                  height: "15px",
                                                  marginRight: "5px",
                                                }}
                                                src={require("../assets/images/expand-open.png")}
                                              />
                                            ) : (
                                              <img
                                                onClick={(e) => {
                                                  setId(item?._id);
                                                  // search(item);
                                                  showDetail(
                                                    e,
                                                    item?.eventId,
                                                    item?.eventType,
                                                  );
                                                }}
                                                style={{
                                                  height: "15px",
                                                  marginRight: "5px",
                                                }}
                                                src={require("../assets/images/expand-close.png")}
                                              />
                                            )}{" "}
                                            {startCase(item?.gameType) ||
                                              startCase(
                                                objNew.betCheckObj[
                                                  item?.eventType
                                                ],
                                              )}{" "}
                                            <BiSolidRightArrow
                                              className="angle_unicode"
                                              color="rgb(197,208,215)"
                                              size={11}
                                            />
                                            <span style={{ fontWeight: "600" }}>
                                              {item?.matchName}
                                            </span>
                                          </>
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          {helpers.currencyFormat(
                                            Math.abs(item?.stake),
                                          )}
                                        </td>{" "}
                                        <td style={{ textAlign: "right" }}>
                                          {item?.amount ? (
                                            Math.sign(item?.amount) === -1 ? (
                                              <span className="text-danger">
                                                (
                                                {helpers.currencyFormat(
                                                  Math.abs(item?.amount),
                                                )}
                                                )
                                              </span>
                                            ) : (
                                              helpers.currencyFormat(
                                                Math.abs(item?.amount),
                                              )
                                            )
                                          ) : (
                                            "-"
                                          )}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          {" "}
                                          {item?.amount ? (
                                            Math.sign(item?.amount) !== -1 ? (
                                              <span className="text-danger">
                                                (
                                                {helpers.currencyFormat(
                                                  Math.abs(item?.amount),
                                                )}
                                                )
                                              </span>
                                            ) : (
                                              helpers.currencyFormat(
                                                Math.abs(item?.amount),
                                              )
                                            )
                                          ) : (
                                            "-"
                                          )}
                                        </td>
                                        {!user?.userType == "agent" && (
                                          <>
                                            <td style={{ textAlign: "right" }}>
                                              0.00
                                            </td>{" "}
                                            <td style={{ textAlign: "right" }}>
                                              0.00
                                            </td>{" "}
                                            <td style={{ textAlign: "right" }}>
                                              0.00
                                            </td>{" "}
                                            <td style={{ textAlign: "right" }}>
                                              0.00
                                            </td>{" "}
                                          </>
                                        )}
                                        <td
                                          style={{
                                            textAlign: "right",
                                            color:
                                              item?.commission > 0 ? "red" : "",
                                          }}
                                        >
                                          {item?.commission > 0
                                            ? `(${helpers.currencyFormat(
                                                item?.commission,
                                              )})`
                                            : helpers.currencyFormat(
                                                item?.commission,
                                              )}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          {item?.amount ? (
                                            Math.sign(item?.amount) !== -1 ? (
                                              <span className="text-danger">
                                                (
                                                {helpers.currencyFormat(
                                                  Math.abs(item?.amount),
                                                )}
                                                )
                                              </span>
                                            ) : (
                                              helpers.currencyFormat(
                                                Math.abs(item?.amount),
                                              )
                                            )
                                          ) : (
                                            "-"
                                          )}
                                        </td>
                                      </tr>
                                      {id == item?._id &&
                                        detailsData?.length > 0 &&
                                        detailsData?.map((obj) => {
                                          return (
                                            <tr
                                              className="inner-table"
                                              id={item?.eventId}
                                              // style={{ display: getProperty }}
                                              key={item?.eventId}
                                            >
                                              <td
                                                style={{
                                                  paddingLeft: "15px",
                                                }}
                                              >
                                                {obj?.betFaireType == "betfair"
                                                  ? "Match Odds"
                                                  : startCase(
                                                      obj?.betFaireType,
                                                    )}
                                              </td>{" "}
                                              <td
                                                style={{ textAlign: "right" }}
                                              >
                                                {helpers.currencyFormat(
                                                  obj?.stake || 0,
                                                )}
                                              </td>
                                              <td
                                                style={{ textAlign: "right" }}
                                              >
                                                {obj?.amount ? (
                                                  Math.sign(obj?.amount) ===
                                                  -1 ? (
                                                    <span class="text-danger">
                                                      {helpers.currencyFormat(
                                                        Math.abs(obj?.amount),
                                                      )}{" "}
                                                    </span>
                                                  ) : (
                                                    helpers.currencyFormat(
                                                      Math.abs(obj?.amount),
                                                    )
                                                  )
                                                ) : (
                                                  0
                                                )}
                                              </td>{" "}
                                              <td
                                                style={{ textAlign: "right" }}
                                              >
                                                {obj?.amount ? (
                                                  Math.sign(obj?.amount) !==
                                                  -1 ? (
                                                    <span class="text-danger">
                                                      {helpers.currencyFormat(
                                                        Math.abs(obj?.amount),
                                                      )}{" "}
                                                    </span>
                                                  ) : (
                                                    helpers.currencyFormat(
                                                      Math.abs(obj?.amount),
                                                    )
                                                  )
                                                ) : (
                                                  0.0
                                                )}
                                              </td>{" "}
                                              <td
                                                style={{ textAlign: "right" }}
                                              >
                                                {helpers.currencyFormat(
                                                  obj?.commission,
                                                )}
                                              </td>{" "}
                                              {!user?.userType == "agent" && (
                                                <>
                                                  <td>0.00</td> <td>0.00</td>
                                                  <td>0.00</td>
                                                  <td>0.00</td>
                                                </>
                                              )}
                                              <td
                                                style={{ textAlign: "right" }}
                                              >
                                                {obj?.amount ? (
                                                  Math.sign(obj?.amount) !==
                                                  -1 ? (
                                                    <span class="text-danger">
                                                      {helpers.currencyFormat(
                                                        Math.abs(obj?.amount),
                                                      )}{" "}
                                                    </span>
                                                  ) : (
                                                    helpers.currencyFormat(
                                                      Math.abs(obj?.amount),
                                                    )
                                                  )
                                                ) : (
                                                  0
                                                )}
                                              </td>{" "}
                                            </tr>
                                          );
                                        })}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={12}>
                                <span>
                                  You have no bets in this time period.
                                </span>
                              </td>
                            </tr>
                          )}
                          {data && data?.length > 0 && (
                            <>
                              <tr className="total-bottom">
                                <th scope="col">Total</th>
                                <th scope="col">
                                  {helpers.currencyFormat(Math.abs(obj?.stake))}
                                </th>{" "}
                                <th>
                                  {obj?.downlinePnl ? (
                                    Math.sign(obj?.downlinePnl) === -1 ? (
                                      <span className="text-danger">
                                        (
                                        {helpers.currencyFormat(
                                          Math.abs(obj?.downlinePnl),
                                        )}
                                        )
                                      </span>
                                    ) : (
                                      helpers.currencyFormat(
                                        Math.abs(obj?.downlinePnl),
                                      )
                                    )
                                  ) : (
                                    "-"
                                  )}
                                </th>
                                <th>
                                  {" "}
                                  {obj?.downlinePnl ? (
                                    Math.sign(obj?.downlinePnl) !== -1 ? (
                                      <span className="text-danger">
                                        (
                                        {helpers.currencyFormat(
                                          obj?.downlinePnl,
                                        )}
                                        )
                                      </span>
                                    ) : (
                                      helpers.currencyFormat(
                                        Math.abs(obj?.downlinePnl),
                                      )
                                    )
                                  ) : (
                                    "-"
                                  )}
                                </th>
                                {!user?.userType == "agent" && (
                                  <>
                                    <th scope="col">0.00</th>{" "}
                                    <th scope="col">0.00</th>{" "}
                                    <th scope="col">0.00</th>{" "}
                                    <th scope="col">0.00</th>{" "}
                                  </>
                                )}
                                <th style={{ color: "red" }}>
                                  ({helpers.currencyFormat(obj?.commission)})
                                </th>
                                <th>
                                  {obj?.downlinePnl ? (
                                    Math.sign(obj?.downlinePnl) !== -1 ? (
                                      <span className="text-danger">
                                        (
                                        {helpers.currencyFormat(
                                          obj?.downlinePnl,
                                        )}
                                        )
                                      </span>
                                    ) : (
                                      helpers.currencyFormat(
                                        Math.abs(obj?.downlinePnl),
                                      )
                                    )
                                  ) : (
                                    "-"
                                  )}
                                </th>
                              </tr>
                            </>
                          )}
                        </>
                      </tbody>
                    </Table>

                    {data && data?.length > 0 && (
                      <Pagination
                        handlePageClick={handlePageClick}
                        pageCount={pageCount}
                        viewpage={viewpage}
                      />
                    )}
                  </div>
                </section>
              </Col>
            ) : (
              ""
            )}
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default AprofitMarket;
